module.exports = __webpack_public_path__ + "img/engelstrompete_2.a3fed19b.jpg";